export default {
  custom_option: 'Własna',
  zero_option: 'Bez napiwku',
};
